import React from "react";
import {connect} from "react-redux";

import LookListFeature from "../../lookNavigation/lookMain/lookListFeature/lookListFeature";
import LookWizardSectionListFeature from "../../lookNavigation/lookMain/lookWizard/lookWizardSectionListFeature";
import {WIZARD_GROUP_TYPES} from "../../../../interfaces/wizardItemInterface";

const preventRequiredFunc = () => {};

const LookAllWallsTutorialHighlightFeature = (props) => {

  const {lookAllWallsTutorial, wizardActiveItem} = props;
  const {left, top, height, width, lookFeature} = lookAllWallsTutorial;

  let style = {
    position: "fixed",
    left,
    top,
    height,
    width,
    textAlign: "left",
  }

  if (wizardActiveItem) {
    return <LookWizardSectionListFeature lookFeature={lookFeature}
                                         wizardGroup={{
                                           id: "9999",
                                           nodeType: WIZARD_GROUP_TYPES.group,
                                           groupName: "Tutorial",
                                           enabled: true,
                                         }}
                                         imageCanvas={{}}
                                         isAllWallsTutorialItem={true}
                                         updateLookCartItem={preventRequiredFunc}
                                         maxClickCountReached={preventRequiredFunc}
                                         style={style}
                                         navItems={[]}/>
  }

  return <LookListFeature style={style}
                          isAllWallsTutorialItem={true}
                          lookFeature={lookFeature}
                          navItems={[]}/>
};

const mapStateToProps = (store) => {
  const {lookAllWallsTutorial, lookViewType} = store.lookState;
  const {wizardActiveItem} = store.wizardState;
  const {isMobile} = store.serverState;
  return {
    lookAllWallsTutorial,
    lookViewType,
    isMobile,
    wizardActiveItem,
  };
};

export default (
  connect(mapStateToProps)(LookAllWallsTutorialHighlightFeature)
)
